// src/app/shared/name-change-requests/columns.tsx
"use client";

import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import { Text } from "rizzui";
import { NameChangeDataInterface } from "../../../data/name-change";
import { MoreActionsNameChange } from "../../../components/table-utils/name-change-more-actions";

const columnHelper = createColumnHelper<NameChangeDataInterface>();

export const NameChangeColumns = [
  columnHelper.accessor("id", {
    header: "Request ID",
    size: 150,
    cell: (info) => (
      <Text className="text-sm font-medium">{info.getValue()}</Text>
    ),
  }),
  columnHelper.accessor("currentName", {
    header: "Current Name",
    size: 200,
    cell: (info) => <Text className="text-sm">{info.getValue()}</Text>,
  }),
  columnHelper.accessor("requestedName", {
    header: "Requested Name",
    size: 200,
    cell: (info) => <Text className="text-sm">{info.getValue()}</Text>,
  }),
  columnHelper.accessor("reason", {
    header: "Reason",
    size: 250,
    cell: (info) => <Text className="text-sm truncate">{info.getValue()}</Text>,
  }),
  columnHelper.accessor("dateRequested", {
    header: "Date Requested",
    size: 180,
    cell: (info) => (
      <Text className="text-sm">
        {new Date(info.getValue()).toLocaleString()}
      </Text>
    ),
  }),
  columnHelper.accessor("status", {
    header: "Status",
    size: 130,
    cell: (info) => (
      <Text className="text-sm capitalize">{info.getValue()}</Text>
    ),
  }),
  columnHelper.display({
    id: "actions",
    header: "Actions",
    size: 120,
    cell: ({ row, table: { options } }) => (
      <MoreActionsNameChange
        id={row.original.id}
        onApprove={() =>
          options.meta?.updateRow?.(row.index, { status: "approved" })
        }
        onDeny={() =>
          options.meta?.updateRow?.(row.index, { status: "rejected" })
        }
      />
    ),
  }),
];
